import { render, staticRenderFns } from "./CvUnblockSection.vue?vue&type=template&id=10c9abd5&scoped=true"
import script from "./CvUnblockSection.vue?vue&type=script&lang=js"
export * from "./CvUnblockSection.vue?vue&type=script&lang=js"
import style0 from "./CvUnblockSection.vue?vue&type=style&index=0&id=10c9abd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c9abd5",
  null
  
)

export default component.exports